import "./Modal.css";

export default function Modal({ open }) {
  return <div className={"Modal " + (open ? "open" : "")}>{open}</div>;
}
